if (!customElements.get('lf-personalization')) {
  customElements.define(
    'lf-personalization',
    class ProductPersonalization extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-photo-input]');
        this.fileName = this.querySelector('[data-file-name]');
        this.error = this.querySelector('[data-photo-error]');
        this.input?.addEventListener('change', () => this.validatePhoto());
      }

      validatePhoto() {
        const file = this.input.files?.[0];
        const maximumSize = 20 * 1024 * 1024;
        const allowedTypes = ['image/jpeg', 'image/png'];

        this.input.setCustomValidity('');
        this.error.hidden = true;
        this.error.textContent = '';
        this.fileName.textContent = file ? file.name : 'Aucun fichier sélectionné';

        if (!file) return;

        if (!allowedTypes.includes(file.type)) {
          this.showError('Choisissez une image au format JPG ou PNG.');
          return;
        }

        if (file.size > maximumSize) {
          this.showError('Cette image dépasse 20 Mo. Choisissez un fichier plus léger.');
        }
      }

      showError(message) {
        this.input.setCustomValidity(message);
        this.error.textContent = message;
        this.error.hidden = false;
        this.input.value = '';
        this.fileName.textContent = 'Aucun fichier sélectionné';
      }
    }
  );
}
